import { useMemo } from 'react';
import { tailwind } from '@circlefin/tailwind';
import classNames from 'classnames';

const useFilterSize = ({ start, size = 0 })=>{
    return useMemo(()=>classNames('w-full', tailwind.colStart(start), tailwind.colSpan(size)), [
        size,
        start
    ]);
};

export { useFilterSize };
//# sourceMappingURL=TableFilters.Filter.es.js.map
